<template>
  <UkiModal :modalId="modalId" title="Отмена события" @close="$emit('close')" @ok="$emit('ok')">
    Отменить последнее событие?
  </UkiModal>
</template>

<script>
import UkiModal from "@/components/UkiModal";

export default {
  name: "CancelLastEventModal",
  components: {UkiModal},
  props: ["modalId"],
  emits: ["close", "ok"],
}
</script>

<style scoped>

</style>